// extracted by mini-css-extract-plugin
export default {"service-list":"store-services__service-list___OhF3t","service-list-item":"store-services__service-list-item___IW2By"};